import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import '../styling/PastExperience.css';

function PastExperience() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const experienceData = [
    {
      role: "Founder & Lead Engineer",
      company: "Payora",
      type: "Fintech Super App",
      period: "2023 - Present",
      description: "Built an all-in-one fintech platform for airtime & data, bill payments, wallet transfers and virtual cards",
      highlights: [
        "Built an all-in-one fintech platform for airtime & data, bill payments, wallet transfers and virtual cards",
        "Developed the mobile app using React Native and backend in Django",
        "Implemented wallet ledger systems and KYC tiers",
        "Integrated API providers including Flutterwave, Kora, PaymentPoint and Maplerad",
        "Scaled platform to thousands of users handling real transactions"
      ],
      skills: ["React Native", "Django", "MySQL", "Flutterwave", "System Architecture", "Leadership"],
      link: "https://payora.app"
    },
    {
      role: "Software Engineer (Freelance)",
      company: "Upwork",
      type: "Freelance Platform",
      period: "2021 - Present",
      description: "Top Rated Plus freelancer delivering production-ready mobile and backend solutions globally",
      highlights: [
        "Top Rated Plus freelancer with over $40k earned",
        "Delivered production mobile and backend solutions for clients globally",
        "Built and deployed React Native apps to Apple App Store and Google Play",
        "Developed scalable Django REST APIs powering authentication, wallet systems, payments and KYC",
        "Led full lifecycle development from architecture to deployment and maintenance"
      ],
      skills: ["React Native", "Python", "Django", "TypeScript", "Mobile Development", "Full Stack"],
      link: "https://www.upwork.com/freelancers/~010ebf744f59d2c8b5"
    },
    {
      role: "Mobile Engineer",
      company: "Ebony Technology",
      type: "Tech Solutions",
      period: "July 2023 - December 2023",
      description: "Developed mobile solutions for UK-based tech company creating digital solutions for businesses worldwide",
      highlights: [
        "Developed React Native mobile applications",
        "Integrated payment and authentication systems",
        "Optimized app performance for iOS and Android",
        "Collaborated with UI/UX designers on user experience",
        "Implemented best practices for mobile development"
      ],
      skills: ["React Native", "Expo", "iOS", "Mobile", "Axios"],
      link: "https://ebonytechnology.co.uk/"
    },
    {
      role: "Co-Founder",
      company: "Tech Hive Nigeria",
      type: "Tech Community",
      period: "2023 - Present",
      description: "Co-founded dynamic tech community fostering knowledge sharing, networking, and skill development",
      highlights: [
        "Built a tech community with 100+ members spanning the globe",
        "Organized tech events, workshops, and networking sessions",
        "Created collaborative space for knowledge sharing",
        "Managed community engagement and growth strategies",
        "Mentored emerging developers and tech enthusiasts"
      ],
      skills: ["Leadership", "Community Management", "Event Planning", "Mentoring", "Networking"],
      link: "https://techhive.ng/our-founders"
    },
    {
      role: "Technical Writer",
      company: "TechRanter",
      type: "Tech Blog",
      period: "2019 - Present",
      description: "Contributing technical content, reviews, and insights on latest gadgets and tech trends",
      highlights: [
        "Written 50+ technical articles and reviews",
        "Researched and analyzed emerging tech trends",
        "Managed GitHub documentation projects",
        "Engaged with global tech community",
        "Built strong online presence"
      ],
      skills: ["Technical Writing", "Research", "GitHub", "Content Strategy", "SEO"],
      link: "https://techranter.com"
    },
    {
      role: "Blogger",
      company: "CYBER NG",
      type: "News & Information",
      period: "2019 - Present",
      description: "Contributing writer for leading information platform covering news across Nigeria, Africa and globally",
      highlights: [
        "Written 100+ blog posts and news articles",
        "Researched and verified information for accuracy",
        "Optimized content for SEO and engagement",
        "Built audience following of 10,000+ readers",
        "Covered emerging technologies and industry trends"
      ],
      skills: ["WordPress", "Writing", "SEO", "Research", "Content Management"],
      link: "https://cyber.ng"
    }
  ];

  const toggleExpanded = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section className="experience-section">
      <Container className="experience-container">
        {/* Header */}
        <div className="experience-header">
          <span className="section-accent">Career Journey</span>
          <h2 className="section-title">
            Work <span className="title-highlight">Experience</span>
          </h2>
          <p className="section-subtitle">
            Building products that matter across fintech, mobile, and web technologies
          </p>
          <div className="title-underline"></div>
        </div>

        {/* Timeline */}
        <div className="experience-timeline">
          {experienceData.map((experience, index) => (
            <div key={index} className="timeline-item">
              {/* Timeline Dot */}
              <div className="timeline-marker">
                <div className="timeline-dot"></div>
              </div>

              {/* Experience Card */}
              <div className="experience-card">
                <div className="card-top">
                  <div className="card-header">
                    <div className="header-content">
                      <h3 className="card-role">{experience.role}</h3>
                      <p className="card-company">{experience.company}</p>
                      <p className="card-type">{experience.type}</p>
                    </div>
                    <span className="card-period">{experience.period}</span>
                  </div>

                  <p className="card-description">{experience.description}</p>
                </div>

                {/* Expandable Section */}
                <button 
                  className={`expand-btn ${expandedIndex === index ? 'expanded' : ''}`}
                  onClick={() => toggleExpanded(index)}
                  aria-expanded={expandedIndex === index}
                >
                  <span className="expand-icon">→</span>
                  {expandedIndex === index ? 'Show Less' : 'Show More'}
                </button>

                {expandedIndex === index && (
                  <div className="card-expanded">
                    <div className="highlights-section">
                      <h4 className="highlights-title">Key Highlights</h4>
                      <ul className="highlights-list">
                        {experience.highlights.map((highlight, idx) => (
                          <li key={idx}>{highlight}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="skills-section">
                      <h4 className="skills-title">Technologies & Skills</h4>
                      <div className="skills-tags">
                        {experience.skills.map((skill, idx) => (
                          <span key={idx} className="skill-tag">{skill}</span>
                        ))}
                      </div>
                    </div>

                    <a 
                      href={experience.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="card-link"
                    >
                      <span className="link-icon">🔗</span>
                      Visit {experience.company}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Summary Stats */}
        <div className="experience-summary">
          <div className="summary-card">
            <div className="summary-number">7</div>
            <div className="summary-label">Roles</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-card">
            <div className="summary-number">5+</div>
            <div className="summary-label">Years Active</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-card">
            <div className="summary-number">∞</div>
            <div className="summary-label">Learning</div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default PastExperience;